import { baseURL, getIdToken } from "./client";

// Axios
import axios from "axios";

/**
 *
 * @param {number} label Box's label number
 * @returns object
 */

export const getBoxDetails = async label => {
  return axios({
    baseURL,
    url: `/boxes/${label}`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
  }).then(response => response.data);
};

/**
 *
 *
 *
 * @param {string} label
 */

export const getBoxByLabel = label => ({
  box: {
    boxId: 1,
    boxLabel: "343889GHK-001",
    scanCode: "343889GHK-001",
  },
});

/**
 *
 * @param {string} label
 */

export const getItemsOfBoxByLabel = async label => {
  return axios({
    baseURL,
    url: `/boxes/${label}/items`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
  }).then(response => response.data);
};

/**
 *
 * @param {string} waybillNumber
 * @param {string} boxLabel
 * @param {"picked_up"|"not_picked"} status
 * @returns
 */

export const updateBoxStatus = async (waybillNumber, boxLabel, status) => {
  return axios({
    baseURL,
    url: `/shipments/${waybillNumber}/boxes/${boxLabel}/status`,
    method: "PATCH",
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
    data: { status },
  }).then(response => response.data);
};

/**
 *
 * @param {string} waybillNumber
 * @returns {Promise<{success: boolean, flippedBoxLabels: string[], alreadyPickedBoxLabels: string[], failedBoxLabels: string[], updatedShipment: object}>}
 */

export const markAllBoxesPickedUp = async waybillNumber => {
  return axios({
    baseURL,
    url: `/shipments/${waybillNumber}/boxes/mark-all-picked-up`,
    method: "PATCH",
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
  }).then(response => response.data);
};

/**
 *
 * @param {string} waybillNumber
 * @param {string} boxLabel
 * @returns
 */

export const getBoxStatusHistory = async (waybillNumber, boxLabel) => {
  return axios({
    baseURL,
    url: `/shipments/${waybillNumber}/boxes/${boxLabel}/status-history`,
    headers: {
      Authorization: `bearer ${await getIdToken()}`,
    },
  }).then(response => response.data);
};
